import { render, staticRenderFns } from "./DisplayMediumTypeChip.vue?vue&type=template&id=af30d5f4&scoped=true&"
import script from "./DisplayMediumTypeChip.vue?vue&type=script&lang=js&"
export * from "./DisplayMediumTypeChip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af30d5f4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VChip,VIcon})
